import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layouts/paginated-layout.js";
import { Subpage } from "course-components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Subpage slug="welcome" mdxType="Subpage">
      <h3>{`Welcome!`}</h3>
      <p>{`This course will challenge you to think on a new level about interactivity in websites.
We'll cover the fundamental programming concepts you need to survive as a web designer
using JavaScript and related technologies.`}</p>
    </Subpage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      